module.exports = __webpack_public_path__ + "img/screenshot.1b8abf16.png";